/**
 * SELECTION SUMMARY COMPONENT
 * 
 * Right panel showing selected products with running total
 */

import React from 'react';

const SelectionSummary = ({ 
  selections = [], 
  onRemove, 
  onClientSupplied, 
  onSpecialOrder 
}) => {
  const total = selections.reduce((sum, s) => sum + (s.client_price || 0), 0);
  
  return (
    <div className="summary-panel">
      <h3>Selected Products</h3>
      
      <div className="selection-list">
        {selections.length === 0 ? (
          <p className="empty-state">No products selected yet</p>
        ) : (
          selections.map(selection => (
            <div key={selection.selection_id} className="selection-item">
              <div className="selection-image">
                {selection.product_image ? (
                  <img src={selection.product_image} alt={selection.product_name} />
                ) : (
                  <div style={{ 
                    width: '100%', 
                    height: '100%', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    background: '#f1f5f9',
                    fontSize: '1.5rem'
                  }}>
                    📦
                  </div>
                )}
              </div>
              <div className="selection-details">
                <p className="selection-fixture">{selection.fixture_label}</p>
                <p className="selection-product">
                  {selection.client_supplied 
                    ? `Client Supplied: ${selection.product_name}`
                    : selection.special_order
                      ? `Special Order: ${selection.product_name}`
                      : selection.product_name
                  }
                </p>
                <p className="selection-price">
                  {selection.client_supplied 
                    ? `Allowance: $${selection.allowance_amount || 0}`
                    : `$${(selection.client_price || 0).toFixed(0)}`
                  }
                </p>
              </div>
              <button
                className="selection-remove"
                onClick={() => onRemove(selection.selection_id)}
                title="Remove selection"
              >
                ×
              </button>
            </div>
          ))
        )}
      </div>
      
      <div className="selection-total">
        <span>Products Total</span>
        <span className="total-amount">${total.toFixed(0)}</span>
      </div>
      
      <div className="special-options">
        <button className="option-btn" onClick={onClientSupplied}>
          + Client Supplying Product
        </button>
        <button className="option-btn" onClick={onSpecialOrder}>
          + Special Order Item
        </button>
      </div>
    </div>
  );
};

export default SelectionSummary;
